import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_ID;
const KEY = "jfn_consent";

function loadGa() {
  if (!GA_ID || window.gtag) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("consent", "default", { ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied", analytics_storage: "granted" });
  window.gtag("config", GA_ID, { anonymize_ip: true, send_page_view: false });
}

export function Analytics() {
  const [choice, setChoice] = useState(() => localStorage.getItem(KEY));
  const loc = useLocation();
  useEffect(() => {
    if (choice === "granted") loadGa();
  }, [choice]);
  useEffect(() => {
    if (choice === "granted" && window.gtag) window.gtag("event", "page_view", { page_path: loc.pathname, page_title: document.title });
  }, [loc.pathname, choice]);
  if (!GA_ID || choice) return null;
  const set = (v) => { localStorage.setItem(KEY, v); setChoice(v); };
  return (
    <div className="pb-safe fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-xl rounded-xl border border-[#e3ece6] bg-white p-4 shadow-2xl sm:inset-x-auto sm:right-6" role="dialog" aria-label="Cookie consent" data-testid="consent-banner">
      <p className="text-sm text-slate-700">We use analytics cookies to understand how Jobfixnow is used and improve it. No advertising cookies.</p>
      <div className="mt-3 flex gap-2">
        <button className="btn-green btn-sm" onClick={() => set("granted")} data-testid="consent-accept">Accept analytics</button>
        <button className="btn-outline btn-sm" onClick={() => set("denied")} data-testid="consent-decline">Decline</button>
      </div>
    </div>
  );
}
